import errorBoundary from '@ifeng-fe/errorBoundary';
import Titile from './Titile';
import React from 'react';
import style from './index.css';
import Detail from './Detail';
import PropTypes from 'prop-types';
const UpdateInfo = ({ isYesterday, hoursItem }) => {
    const clockicon = hoursItem.titleIcon;

    return (
        <div className={style.Updateinfo}>
            <Titile clockicon={clockicon} isYesterday={isYesterday} time={hoursItem.blockTime} title={hoursItem.blockTitle} />
            {hoursItem.blockList.map((item) => (
                <div key={item.category}>
                    <Detail isYesterday={isYesterday} category={item.category} list={item.dataList} />
                </div>
            ))}
        </div>
    );
};

UpdateInfo.propTypes = {
    isYesterday: PropTypes.bool,
    hoursItem: PropTypes.object,
};

export default errorBoundary(UpdateInfo);
